export const MODAL_STRINGS = {
    AppointmentAlreadyBooked: "You've already booked this appointment",
    AppointmentNoLongerAvailable: 'This appointment is no longer available',
    BackToHome: 'Back to home',
    Close: 'Close',
    GoToAccountsPage: 'If you need to make changes, go to your account page.',
    MaximumVaccineAppointmentHeaderDose1:
        'This patient has an existing COVID-19 vaccine dose 1 appointment',
    MaximumVaccineAppointmentHeaderDose2:
        'This patient has an existing COVID-19 vaccine dose 2 appointment',
    MaximumVaccineAppointmentHeaderBooster:
        'This patient has an existing COVID-19 vaccine booster appointment',
    MaximumVaccineAppointmentBody:
        'Due to limited supply, we can only allow one vaccine appointment per patient at this time.',
    NotCompleted: "Your booking couldn't be completed",
    OK: 'OK',
    PatientTimesOverlap: 'You already have an appointment at this time',
    PhoneIsVerifiedFailure: 'Please verify your phone number to continue.',
    PleaseReenterYourInformation: 'Please re-enter your information',
    PleaseSelectANewTime: 'Please select a new time.',
    PleaseSelectAnotherTime: 'Please select another time to continue.',
    SomethingWentWrong: 'Something went wrong',
    UnableToBook: "The booking didn't go through",
    YouSteppedAway:
        'You stepped away for a while so we cleared your information to protect your privacy.',
    YouveReachedMaximumAppointments:
        "You're at the limit of appointments you can have at once",
    ViewUpcomingAppointments: 'View upcoming appointments',
};
